import { ComponentPropsWithoutRef, forwardRef, MouseEventHandler, RefObject, useEffect, useState } from 'react';

import LNBAccount from './LNBAccount';
import LNBAccountInfo from './LNBAccountInfo';
import LNBAccountSearch from './LNBAccountSearch';
import LNBAccountSearchItem from './LNBAccountSearchItem';
import LNBHeader from './LNBHeader';
import LNBMenu from './LNBMenu';
import LNBMenuItem from './LNBMenuItem';
import LNBSubMenu from './LNBSubMenu';
import LNBSubMenuItem from './LNBSubMenuItem';
import Button from '@/components/common/Button';

type Props = {
  outerRef: RefObject<HTMLElement | null>;
} & ComponentPropsWithoutRef<'div'>;

const LNB = forwardRef<HTMLDivElement, Props>(({ outerRef, children }, ref) => {
  const [isOpened, setIsOpened] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    outerRef.current?.classList.toggle('lnb_on', isOpened);
    setIsHovered(!isOpened);
  }, [isOpened]);

  useEffect(() => {
    outerRef.current?.classList.toggle('lnb_over', isHovered);
  }, [isHovered]);

  const onClickFoldButton = () => {
    setIsOpened((prev) => !prev);
  };

  const onMouseOver = () => {
    if (isOpened) return;
    setIsHovered(true);
  };

  const onMouseOut: MouseEventHandler<HTMLDivElement> = (event) => {
    if (!event.relatedTarget) return;
    setIsHovered(false);
  };

  return (
    <div ref={ref} id="mFeature" role="navigation">
      <div className="feature_wrap" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        {children}
      </div>
      <div className="fold_btn" onMouseOver={isHovered ? onMouseOver : () => {}} onMouseOut={onMouseOut}>
        <Button className="btn_opcl" onClick={onClickFoldButton}>
          <span className="ico_wallet ico_opcl">펼침/닫힘</span>
        </Button>
      </div>
    </div>
  );
});

LNB.displayName = 'LNB';

export default Object.assign(LNB, {
  Header: LNBHeader,
  Account: LNBAccount,
  AccountSearch: LNBAccountSearch,
  AccountSearchItem: LNBAccountSearchItem,
  AccountInfo: LNBAccountInfo,
  Menu: LNBMenu,
  MenuItem: LNBMenuItem,
  SubMenu: LNBSubMenu,
  SubMenuItem: LNBSubMenuItem
});
